/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */
import { css, jsx } from '@emotion/react'

import { EuiIconTip, EuiPanel } from '@elastic/eui'
import type { EuiPanelProps } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

import type { FunctionComponent } from 'react'

const contentWrapperStyle = css({
  position: 'relative',
})

const adminIconStyle = css({
  position: 'absolute',
  right: 0,
  top: 0,
})

const adminPanelStyle = css({
  display: 'flex',
})

const AdminOnlyPanel: FunctionComponent<EuiPanelProps> = ({
  children,
  css: cssProp,
  ...restProps
}) => (
  <EuiPanel
    css={[adminPanelStyle, cssProp]}
    hasBorder={true}
    hasShadow={false}
    paddingSize='l'
    {...restProps}
  >
    <div css={contentWrapperStyle}>
      <div css={adminIconStyle}>
        <EuiIconTip
          type='eyeClosed'
          color='primary'
          content={
            <FormattedMessage
              id='admin-only-panel.message'
              defaultMessage='Only visible to Elastic'
            />
          }
        />
      </div>

      {children}
    </div>
  </EuiPanel>
)

export default AdminOnlyPanel
